import React, {Component} from 'react';
import "../CSS/appointment.css"
import ProgressBarElement from "../Components/ProgressBarElement.js"
import Location from "../Components/Location.js"
import Plans from "../Components/Plans.js"
import ErrorMessage from "../Components/ErrorMessage.js"
import Vehicle from "../Components/Vehicle.js"
import DateTime from "../Components/DateTime.js"
import SubscriptionConfirmation from "../Components/SubscriptionConfirmation.js"
import LocationAddModal from "../Components/LocationAddModal.js"
import AppointmentService from '../utils/AppointmentService.js';
import '../CSS/Template.css'
import Raven from 'raven-js';
import ErrorSnackBar from '../Components/ErrorSnackBar.js';

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export default class NewSubcription extends Component {
  constructor(props){

    super(props);
    Raven.config('https://d726bc9f12eb4be68a884a1a911b6c6f@sentry.io/1244185').install();
    this.state = {
      show: false,
      addresses: [],
      appointmentAddress: null,
      startDate: null,
      appointmentVehicle: null,
      appointmentUpgrades: null,
      allUpgradesMap: [],
      allUpgradesArray: [],
      upgradesMap: [],
      currentLocation: null,
      vehicles: [],
      showLocation: true,
      showVehicle: false,
      showPlans: false,
      showDateTime: false,
      showSummary: false,
      promoAmount: 0,
      subscriptionPlan: null
    }
    this.setError = this.setError.bind(this)
    this.showLocation = this.showLocation.bind(this)
    this.showVehicle = this.showVehicle.bind(this)
    this.selectVehicle = this.selectVehicle.bind(this)
    this.savePlan= this.savePlan.bind(this)
    this.selectDateTime= this.selectDateTime.bind(this)
    this.showDatetimeOnClick = this.showDatetimeOnClick.bind(this)
    this.addVehicle = this.addVehicle.bind(this)
    this.ApptService = new AppointmentService()
    this.ApptService.addresses()
    .then(res =>{
      const addresses = res
      this.setState({ addresses: addresses});
      this.forceUpdate()
      //  this.props.history.replace('/');
    })
    .catch(err =>{
        alert(err);
    })
    this.ApptService.vehicles()
    .then(res =>{
      const vehicles = res
      this.setState({vehicles: vehicles});
      this.forceUpdate()
      //  this.props.history.replace('/');
    })
    .catch(err =>{
        alert(err);
    })
  }
  componentWillMount(){
    var lat = localStorage.getItem('lat')
    var lng = localStorage.getItem('lng')
  }
  showLocation(){
    var otherProgressBars = document.getElementsByClassName('progressBarElement')
    for (var i = 0; i < otherProgressBars.length; i++){
      otherProgressBars[i].style.backgroundColor = "#E5E6E8";
    }
    var vehicleProgressBar = document.getElementById('step1')
    vehicleProgressBar.style.backgroundColor = "#5BBA76";
    this.setState({
      showVehicle: false,
      showLocation: true,
      showPlans: false,
      showDateTime: false,
      showSummary: false,
    });
  }
  showVehicle(addressId) {
    if(addressId){
      this.setState({
        appointmentAddress: addressId,
      });
    }
    if(!this.state.appointmentAddress && !addressId){
      alert("You must select a address first")
    }
    else {
      var appointmentVehicle = this.state.appointmentVehicle
      if(appointmentVehicle){
        var selectedVehicle = ("vehicle" + appointmentVehicle.id)
      }

      var otherProgressBars = document.getElementsByClassName('progressBarElement')
      for (var i = 0; i < otherProgressBars.length; i++){
        otherProgressBars[i].style.backgroundColor = "#E5E6E8";
        otherProgressBars[i].style.color = "black";
      }
      var vehicleProgressBar = document.getElementById('step2')
      vehicleProgressBar.style.backgroundColor = "#5BBA76";
      vehicleProgressBar.style.color = "white";
      this.setState({
        showVehicle: true,
        showLocation: false,
        showPlans: false,
        showDateTime: false,
        showSummary: false,
      });
    }
  }
  selectVehicle(vehicle) {
      if(vehicle){
        this.setState({
          appointmentVehicle: vehicle,
        })
      }
      if(!this.state.appointmentVehicle && !vehicle){
        alert("You must select a vehicle first")
      }
      else {
        var otherProgressBars = document.getElementsByClassName('progressBarElement')
        for (var i = 0; i < otherProgressBars.length; i++){
          otherProgressBars[i].style.backgroundColor = "#E5E6E8";
          otherProgressBars[i].style.color = "black";
        }
        var vehicleProgressBar = document.getElementById('step3')
        vehicleProgressBar.style.backgroundColor = "#5BBA76";
        vehicleProgressBar.style.color = "white";
        this.setState({
          showVehicle: false,
          showLocation: false,
          showPlans: true,
          showDateTime: false,
          showSummary: false
        });
    }
  }
  selectDateTime(dateTime){
    if(dateTime){
      this.setState({
        startDate: dateTime,
      })
    }
    if(!this.state.appointmentVehicle && !dateTime && !this.state.appointmentAddress){
      alert("You must select a Vehicle, Location and Service first")
    }
    else {
      var otherProgressBars = document.getElementsByClassName('progressBarElement')
      for (var i = 0; i < otherProgressBars.length; i++){
        otherProgressBars[i].style.backgroundColor = "#E5E6E8";
        otherProgressBars[i].style.color = "black";
      }
      var vehicleProgressBar = document.getElementById('step5')
      vehicleProgressBar.style.backgroundColor = "#5BBA76";
      vehicleProgressBar.style.color = "white";
      this.setState({
        showVehicle: false,
        showLocation: false,
        showPlans: false,
        showDateTime: false,
        showSummary: true,
        errorMessage: '',
        color: null
      });
    }
  }
  selectService(service) {
    if(service){
      this.setState({
        appointmentService: service
      })
    }
  }
  savePlan(plan) {
    this.setState({
      subscriptionPlan: plan
    })
    this.showDatetimeOnClick()
  }
  showDatetimeOnClick(){
    if(!this.state.appointmentVehicle && !this.state.appointmentAddress){
      alert("You must select a Vehicle, Location and Service first")
    }
    else{
      var otherProgressBars = document.getElementsByClassName('progressBarElement')
      for (var i = 0; i < otherProgressBars.length; i++){
        otherProgressBars[i].style.backgroundColor = "#E5E6E8";
        otherProgressBars[i].style.color = "black";
      }
      var vehicleProgressBar = document.getElementById('step4')
      vehicleProgressBar.style.backgroundColor = "#5BBA76";
      vehicleProgressBar.style.color = "white";
      this.setState({
        showVehicle: false,
        showLocation: false,
        showPlans: false,
        showDateTime: true,
        showSummary: false
      });
    }
  }
  selectLocation(address){
    this.setState({
      appointmentAddress: address
    })
  }
  addVehicle() {
    this.setState({
      showVehicle: true,
      showLocation: false,
      showPlans: false,
      showDateTime: false,
      showSummary: false,
      appointmentVehicle: null,
    });
  }
  setOpenToFalse = () => {
    this.setState({
      open:false
    })
  }
  setError = (errorMessage) =>{
    this.setState({
      errorMessage: errorMessage,
      open: true,
      color: '#c42d2d'
    })
  }
  render() {
    return (
      <div>
        <div className = "progressBar">
        <Route exact path ="/new-appointment/location" component={Location}/>
          <ProgressBarElement showLocation = {this.showLocation} showService = {this.selectVehicle} showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} color={'#5BBA76'} textColor='white' stepNumber = "1" step="Location"/>
          <ProgressBarElement showLocation = {this.showLocation}  showService = {this.selectVehicle}  showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} stepNumber = "2" step="Vehicle"/>
          <ProgressBarElement showLocation = {this.showLocation}  showService = {this.selectVehicle}  showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} stepNumber = "3" step="Plan"/>
          <ProgressBarElement showLocation = {this.showLocation}  showService = {this.selectVehicle}  showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} stepNumber = "4" step="Date"/>
          <ProgressBarElement showLocation = {this.showLocation}  showService = {this.selectVehicle}  showVehicle = {this.showVehicle} showDateTime = {this.selectService} showDatetimeOnClick = {this.showDatetimeOnClick} stepNumber = "5" step="Summary"/>
        </div>
        <div className = 'wrapper'>
        {this.state.showLocation &&
          <Location setError = {this.setError} showOnlyWork={true} selectLocation = {this.selectLocation} selectedLocation = {this.state.appointmentAddress} addresses={this.state.addresses} currentLocation={this.state.currentLocation} selectLocation={this.showVehicle} setError={this.setError} />
        }
        {this.state.showVehicle &&
            <Vehicle ref={this.vehicle} setError = {this.setError} vehicles={this.state.vehicles} selectVehicle={this.selectVehicle} selectedVehicle = {this.state.appointmentVehicle}  setError={this.setError}/>}
       {this.state.showPlans &&
              <Plans setError = {this.setError} selectPlan = {this.savePlan} vehicle = {this.state.appointmentVehicle} setError={this.setError} />}
      {this.state.showDateTime &&
              <DateTime setError = {this.setError} showTime={false} selectDateTime = {this.selectDateTime} blackoutDays = {this.state.appointmentAddress.blackout_dates} selectedDateTime = {this.state.startDate}/>}
      {this.state.showSummary &&
                <SubscriptionConfirmation  setError = {this.setError} vehicle = {this.state.appointmentVehicle} startDate = {this.state.startDate} address = {this.state.appointmentAddress}  subscription = {this.state.subscriptionPlan}  setErrors = {this.setError}/>}
        </div>
        {(this.state.errorMessage && this.state.errorMessage.length) &&
          <ErrorSnackBar color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/NewSubscription.js